module.exports = __webpack_public_path__ + "img/05.8593d355.jpg";